import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import Select, { ISelectValue } from '@/components/basicComponents/select';
import { themeVar } from '@/styles/theme';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ITenant } from '../types';

interface AddNewInvestorEntityProps {
  isOpen: boolean;
  advisoryFirmList: ITenant[];
  onClose: () => void;
}

const AddNewInvestorEntity = ({ isOpen, advisoryFirmList, onClose }: AddNewInvestorEntityProps) => {
  const navigate = useNavigate();
  const { handleSubmit, control } = useForm<{ advisoryFirmId: string }>({ defaultValues: { advisoryFirmId: '' } });

  const [selectListData, setSelectListData] = useState<ISelectValue[]>([]);

  useEffect(() => {
    setSelectListData([...new Set(advisoryFirmList.map((el) => ({ label: el.name, value: el.id })))].sort((a, b) => a.label.localeCompare(b.label)));
  }, [advisoryFirmList]);

  const saveValue = (data: { advisoryFirmId: string }) => {
    const { advisoryFirmId } = data;
    const selectedAdvisoryFirmObject = advisoryFirmList.find((el) => el.id === advisoryFirmId);
    navigate(`/investors/create-investor?tenantId=${advisoryFirmId}&tenantName=${selectedAdvisoryFirmObject?.name}&backToTitle=Investors`);
  };

  return (
    <ModalWrappedContent
      isOpen={isOpen}
      onClose={onClose}
      title="Add New Investor Entity"
      confirmButton={{
        name: 'Confirm',
        onClick: handleSubmit(saveValue)
      }}
    >
      <ModalBody>
        <ModalDescription>Select an Advisory Firm</ModalDescription>
        <Controller
          name="advisoryFirmId"
          control={control}
          rules={{
            required: {
              value: true,
              message: 'Advisory Firm is required'
            }
          }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Select
              label="Advisory Firm"
              value={value || ''}
              options={selectListData}
              setValue={onChange}
              errorText={error?.message}
              isRequiredField
              size="lg"
            />
          )}
        />
      </ModalBody>
    </ModalWrappedContent>
  );
};

export default AddNewInvestorEntity;

const ModalBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  gap: 25px;
`;

const ModalDescription = styled.div`
  font-size: 16px;
  text-align: center;
  color: ${themeVar('font.base')};
`;
